import { render, staticRenderFns } from "./requiredDetail.vue?vue&type=template&id=16d7f8d8&scoped=true"
import script from "./requiredDetail.vue?vue&type=script&lang=js"
export * from "./requiredDetail.vue?vue&type=script&lang=js"
import style0 from "./requiredDetail.vue?vue&type=style&index=0&id=16d7f8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d7f8d8",
  null
  
)

export default component.exports